import { Card, Divider, Stack, Typography } from '@healthinal/ui';
import {
  ClinicalReportAnamnesisDto,
  ClinicalReportAnamnesisDtoPreviousDiagnoseStatus,
  ClinicalReportAnamnesisDtoPreviousTherapyStatus,
} from '../../../../../api/generated/model';
import { getPreviousDiagnoseStatusName, getPreviousTherapyStatusName } from '../../../../../utils/anamnesis.ts';
import { formatDateWithGermanMonth } from '../../../../../utils/date.ts';

export function ClinicalReportAnamnesisCard({ anamnesis }: { anamnesis: ClinicalReportAnamnesisDto }) {
  return (
    <Card>
      <Stack>
        <Typography level={'title-lg'}>Gemäss MKB vom {formatDateWithGermanMonth(anamnesis.created)}</Typography>
      </Stack>
      <Divider />
      <Stack gap={2}>
        <CardRow
          title={'Frühere TB Diagnostiziert'}
          value={getPreviousDiagnoseStatusName(anamnesis.previousDiagnoseStatus)}
        />
        {anamnesis.previousDiagnoseStatus === ClinicalReportAnamnesisDtoPreviousDiagnoseStatus.YES && (
          <CardRow
            title={'Frühere TB Diagnose Datum'}
            value={formatDateWithGermanMonth(anamnesis.previousDiagnoseDate) ?? 'Unbekannt'}
          />
        )}
        <CardRow
          title={'Frühere Behandlung mit Antituberkulotika'}
          value={getPreviousTherapyStatusName(anamnesis.previousTherapyStatus)}
        />
        {anamnesis.previousTherapyStatus === ClinicalReportAnamnesisDtoPreviousTherapyStatus.YES && (
          <CardRow
            title={'Frühere TB-Therapie Datum'}
            value={formatDateWithGermanMonth(anamnesis.previousTherapyDate) ?? 'Unbekannt'}
          />
        )}
      </Stack>
    </Card>
  );
}

function CardRow({ title, value }: { title: string; value: string }) {
  return (
    <Stack direction={'row'} gap={2}>
      <Typography flex={1} level={'title-sm'}>
        {title}
      </Typography>
      <Typography flex={2} level={'body-sm'}>
        {value}
      </Typography>
    </Stack>
  );
}
